import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation, ElementRef } from '@angular/core'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { DrugPlan } from '../../models/drug-plan'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { PlanList } from '../../models/plan-list'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentDataService } from '../../gateways/enrollment-data-service'
import { PortalGlobals } from '../../../portalglobals'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { UserDataService } from '../../../user-management/gateways/user-data-service'
import { GroupPlanFilterData } from '../../models/GroupPlanFilterData'
import { stcobModel } from '../../models/stcob-model'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { CurrentUser } from '../../../common/models/current-user'
import { first } from 'lodash'
import { filter } from 'rxjs'

@Component({
    selector: 'groupplan',
    templateUrl: 'group-plans.component.html',
    styleUrls: ['group-plans.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class GroupPlanComponent implements OnInit, OnChanges {
    @ViewChild('myGrid') myGrid: jqxGridComponent
    @ViewChild('srAnnouncer') srAnnouncer!: ElementRef
    @Input() disabled: boolean = false
    @Output() focusSubmit = new EventEmitter<void>();
    @Output() onValueChange: EventEmitter<DrugPlan> = new EventEmitter<DrugPlan>()
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    groupPlanFilterData = {} as GroupPlanFilterData
    public currentUser: CurrentUser = {} as CurrentUser
    isValidAgent: boolean
    planYear: number
    public optionrbPlan: ValidatedRadioButtonModel[] = []
    planList: PlanList[] = [] as PlanList[]
    selPlan: string
    AppDate: Date
    EffectiveDate: Date
    hasError: boolean = false
    loadingIcon: boolean = false
    lengthErrorC: string = ''
    lengthErrorA: string = ''
    lengthErrorG: string = ''
    lengthErrorCU: string = ''
    formValue: string
    stcobDetails: stcobModel[] = []
    errorMsg: string = ''
    enrol: EnrollmentViewModel = {} as EnrollmentViewModel
    @Input() enrollmentDrugViewModel: EnrollmentViewModel
    @Input() disableAppRecievDt: boolean
    @Input() AgentOrgID: Number
    disableEffectiveDate: boolean
    public IsPlanvisible: boolean = false
    public ChangePlan: boolean = false
    noDataFound: boolean = false
    noGrpPlan: boolean
    showWarning: boolean = false
    rowNum: number
    currentRowIndex: number = 0
    source: any = {
        localdata: this.stcobDetails,
        datafields: [
            { name: 'GroupName', type: 'string' },
            { name: 'PrimaryCarrier', type: 'string' },
            { name: 'PrimaryAccount', type: 'string' },
            { name: 'PrimaryGroup', type: 'string' },
            { name: 'SecondaryCarrier', type: 'string' },
            { name: 'SecondaryAccount', type: 'string' },
            { name: 'SecondaryGroup', type: 'string' },
            { name: 'PlanTypeShortName', type: 'string' },
            { name: 'PlanTypeName', type: 'string' },
            { name: 'CAGTypeShortName', type: 'string' },
            { name: 'CAGTypeName', type: 'string' },
            { name: 'GroupFlag', type: 'string' },
            { name: 'OptOutFlag', type: 'string' },
            { name: 'STCOBFlag', type: 'string' },
            { name: 'PBP', type: 'string' },
            { name: 'RxEnrollXREFID', type: 'string' },
            { name: 'CUID', type: 'string' },
            { name: 'CAGID', type: 'string' }
        ],
        datatype: 'array'
    }

    dataAdapter: any = new jqx.dataAdapter(this.source, { filter: true });

    columns: any[] = [
        { text: 'Group Name', datafield: 'GroupName', width: 300 },
        { text: 'CUID', datafield: 'CUID', width: 70 },
        {
            text: 'Primary Carrier',
            datafield: 'PrimaryCarrier',
            width: 80,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Primary</div><div>Carrier</div></div>'
            }
        },
        {
            text: 'Primary Account',
            datafield: 'PrimaryAccount',
            width: 140,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Primary</div><div>Account</div></div>'
            }
        },
        {
            text: 'Primary Group',
            datafield: 'PrimaryGroup',
            width: 110,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Primary</div><div>Group</div></div>'
            }
        },
        {
            text: 'Secondary Carrier',
            datafield: 'SecondaryCarrier',
            width: 90,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Secondary</div><div>Carrier</div></div>'
            }
        },
        {
            text: 'Secondary Account',
            datafield: 'SecondaryAccount',
            width: 130,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Secondary</div><div>Account</div></div>'
            }
        },
        {
            text: 'Secondary Group',
            datafield: 'SecondaryGroup',
            width: 110,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Secondary</div><div>Group</div></div>'
            }
        },
        { text: 'CAGID', datafield: 'CAGID', width: 80 }
    ]

    constructor(
        private _enrollementGateway: EnrollmentGateway,
        private enrollmentdata: EnrollmentDataService,
        public _global: PortalGlobals,
        private userdataservice: UserDataService
    ) { }

    private setupA11y(): void {
        if (!this.myGrid?.elementRef?.nativeElement) return;

        const jqxEl = this.myGrid.elementRef.nativeElement as HTMLElement;
        const gridEl = jqxEl.querySelector('.jqx-grid') as HTMLElement;

        if (!gridEl) return;

        jqxEl.setAttribute('tabindex', '0');
        gridEl.setAttribute('aria-readonly', 'true');

        this.updateVisibleRowCount();

        const rows = gridEl.getAttribute('aria-rowcount') || '0';
        const cols = this.myGrid.columns?.length || 0;
        gridEl.setAttribute('aria-label', `Group plan results grid with ${rows} rows and ${cols} columns`);

        this.fixInnerTabbing(gridEl);
        this.observeAndRemoveTabindex(gridEl);

        if (!jqxEl.hasAttribute('data-keydown-bound')) {
            jqxEl.setAttribute('data-keydown-bound', 'true');

            jqxEl.addEventListener('keydown', (e: KeyboardEvent) => {
                if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].indexOf(e.key) !== -1) {
                    this.activateGridMode(gridEl);
                }
            });
        }
    }

    private observeAndRemoveTabindex(gridEl: HTMLElement): void {
        const clean = () => {
            const wrappers = gridEl.querySelectorAll('[id^="wrapper"], [id^="content"]');

            wrappers.forEach((el: any) => {
                if (el.hasAttribute('tabindex')) {
                    el.removeAttribute('tabindex');
                }
                el.setAttribute('role', 'presentation');
            });
        };

        clean();

        setTimeout(clean, 0);
        setTimeout(clean, 50);
        setTimeout(clean, 150);

        new MutationObserver(() => clean())
            .observe(gridEl, { attributes: true, subtree: true, attributeFilter: ['tabindex'] });
    }

    private activateGridMode(gridEl: HTMLElement): void {
        gridEl.removeAttribute('aria-readonly');

        this.myGrid.selectrow(0);
        gridEl.focus();
    }
    private fixExternalJqxInputs(): void {
        const inputs = document.querySelectorAll('input[id^="jqxWidget"]');

        inputs.forEach((input, index) => {
            const el = input as HTMLElement;

            el.removeAttribute('aria-labelledby');

            if (el.getAttribute('type') === 'textarea') {
                el.setAttribute('type', 'text');
            }

            if (!el.getAttribute('aria-label')) {
                el.setAttribute('aria-label', `Filter input ${index + 1}`);
            }
        });
    }

    private updateVisibleRowCount(): void {
        const gridEl = this.myGrid.elementRef.nativeElement
            .querySelector('.jqx-grid') as HTMLElement;
        if (!gridEl) return;

        const visibleRows = gridEl.querySelectorAll(
            '.jqx-grid-content .jqx-grid-row:not([style*="display: none"])'
        ).length;
        gridEl.setAttribute('aria-rowcount', String(visibleRows));
    }

    private fixInnerTabbing(gridEl: HTMLElement): void {
        gridEl.querySelectorAll('.jqx-grid-cell').forEach(cell => {
            (cell as HTMLElement).removeAttribute('tabindex');
        });

        gridEl.querySelectorAll('input.jqx-filter-input').forEach(input => {
            input.setAttribute('tabindex', '0');
        });
    }

    labelFilterInputs(): void {
        const gridEl = this.myGrid.elementRef.nativeElement as HTMLElement;
        const headers = Array.from(gridEl.querySelectorAll('.jqx-grid-column-header')) as HTMLInputElement[];
        const filters = Array.from(gridEl.querySelectorAll('.jqx-grid-cell-filter-row input')) as HTMLInputElement[];

        filters.forEach((input, index) => {
            const headerText = headers[index]?.innerText?.trim() || `Column ${index + 1}`;
            input.setAttribute('tabindex', '0');
            input.setAttribute('aria-label', `${headerText} filter`);
            input.setAttribute('role', 'textbox');
        });
    }

    myGridOnRowSelect(event: any): void {
        let args = event.args;
        this.currentRowIndex = args.rowindex;
        let row = this.myGrid.getrowdata(args.rowindex)
        console.log('row data: ', row);
        const announcement = this.buildRowAnnouncement(row);
        console.log('announcement: ', announcement);
        this.announce(announcement);
        this.setSTCOBData(row)
    }

    announce(message: string) {
        const el = this.srAnnouncer.nativeElement as HTMLElement;
        el.textContent = '';
        setTimeout(() => {
            el.textContent = message;
        }, 10);
    }

    buildRowAnnouncement(row: any): string {
        return `GroupName ${row.GroupName},
        CUID ${row.CUID},
        PrimaryCarrier ${row.PrimaryCarrier},
        PrimaryAccount ${row.PrimaryAccount},
        PrimaryGroup ${row.PrimaryGroup},
        CAGID ${row.CAGID} This row is selected`;
    }

    setSTCOBData(row: any) {
        var User = localStorage.getItem('UserSessionContext')
        this.currentUser = JSON.parse(User!)

        this.enrollmentDrugViewModel.PLANTYPE = row['PBP']
        this.enrollmentDrugViewModel.STCOBGROUPNAME = row['GroupName']
        this.enrollmentDrugViewModel.PLANTYPENAME = row['PlanTypeShortName']
        if (row['STCOBFlag'] === 'Y') {
            if (this.currentUser.insuranceCompanyName === this._global.insuranceCompanyNameSSI) {
                this.enrollmentDrugViewModel.SECGROUP = row['SecondaryGroup']
                this.enrollmentDrugViewModel.SECCARRIER = row['SecondaryCarrier']
                this.enrollmentDrugViewModel.SECACCOUNT = row['SecondaryAccount']
                this.enrollmentDrugViewModel.GROUP = row['SecondaryGroup']
                this.enrollmentDrugViewModel.CARRIER = row['SecondaryCarrier']
                this.enrollmentDrugViewModel.ACCOUNT = row['SecondaryAccount']
            } else {
                this.enrollmentDrugViewModel.GROUP = row['SecondaryGroup']
                this.enrollmentDrugViewModel.CARRIER = row['SecondaryCarrier']
                this.enrollmentDrugViewModel.ACCOUNT = row['SecondaryAccount']
            }
            this.enrollmentDrugViewModel.ISSTCOB = true
            this.enrollmentDrugViewModel.CHANNELID = row['RxEnrollXREFID']
            this.enrollmentDrugViewModel.CUID = row['CUID']
        } else {
            this.enrollmentDrugViewModel.GROUP = row['PrimaryGroup']
            this.enrollmentDrugViewModel.CARRIER = row['PrimaryCarrier']
            this.enrollmentDrugViewModel.ACCOUNT = row['PrimaryAccount']
            this.enrollmentDrugViewModel.ISSTCOB = false
            this.enrollmentDrugViewModel.CHANNELID = row['RxEnrollXREFID']
            this.enrollmentDrugViewModel.CUID = row['CUID']
        }

        this.enrollmentDrugViewModel.CHANNELID = row['RxEnrollXREFID'];
        this.enrollmentDrugViewModel.CUID = row['CUID'];

        this.enrollmentDrugViewModel.SINGLEGRPNAME =
            this.enrollmentDrugViewModel.STCOBGROUPNAME +
            '-' +
            this.enrollmentDrugViewModel.CARRIER +
            '-' +
            this.enrollmentDrugViewModel.ACCOUNT +
            '-' +
            this.enrollmentDrugViewModel.GROUP

        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentDrugViewModel)
    }

    ngOnInit() {
        if (this.enrollmentDrugViewModel !== undefined) {
            if (this.enrollmentDrugViewModel.SINGLEGRPNAME != undefined && this.enrollmentDrugViewModel.SINGLEGRPNAME !== '') {
                this.ChangePlan = true
            }
        }
    }
    ngAfterViewInit() {
        this.fixInputsOnInit();
        setTimeout(() => {
            const jqxEl = this.myGrid?.elementRef?.nativeElement as HTMLElement;
            const gridEl = jqxEl?.querySelector('.jqx-grid') as HTMLElement;

            if (gridEl) {
                this.observeAndRemoveTabindex(gridEl);
            }
        }, 0);
    }
    private fixInputsOnInit(): void {
        if (!this.myGrid) return;

        const gridHost = this.myGrid.elementRef.nativeElement as HTMLElement;
        const inputs = gridHost.querySelectorAll('input[id^="jqxWidget"]');

        if (!inputs.length) return;

        inputs.forEach((input, index) => {
            const el = input as HTMLElement;

            el.removeAttribute('aria-labelledby');

            if (el.getAttribute('type') === 'textarea') {
                el.setAttribute('type', 'text');
            }

            if (!el.getAttribute('aria-label')) {
                el.setAttribute('aria-label', `Filter input ${index + 1}`);
            }
        });
    }

    private gridInitialized = false;

    ngAfterViewChecked(): void {
        if (this.myGrid && !this.gridInitialized) {
            this.gridInitialized = true;
            this.initGridEvents();
            this.fixInputsOnInit();
        }
    }
    private initGridEvents(): void {
        if (!this.myGrid) return;

        this.myGrid.onBindingcomplete.subscribe(() => {
            setTimeout(() => this.runA11yFix(), 0);
        });

        this.myGrid.onFilter.subscribe(() => {
            setTimeout(() => this.runA11yFix(), 0);
        });

        this.myGrid.onSort.subscribe(() => {
            setTimeout(() => this.runA11yFix(), 0);
        });
    }

    ChangePlanClick(): void {
        this.ChangePlan = false
    }
    showPlans(): void {
        this.lengthErrorA = ''
        this.lengthErrorC = ''
        this.lengthErrorG = ''
        this.lengthErrorCU = ''
        this.errorMsg = ''
        this.hasError = false

        if (this.groupPlanFilterData !== undefined) {
            {
                if (this.groupPlanFilterData.CUID !== undefined && this.groupPlanFilterData.CUID !== '' && this.groupPlanFilterData.CUID.length < 3) {
                    this.lengthErrorCU = 'Minimum 3 characters'
                    this.hasError = true
                }
                if (
                    this.groupPlanFilterData.Account !== undefined &&
                    this.groupPlanFilterData.Account !== '' &&
                    this.groupPlanFilterData.Account.length < 3
                ) {
                    this.lengthErrorA = 'Minimum 3 characters'
                    this.hasError = true
                }
                if (
                    this.groupPlanFilterData.Group !== undefined &&
                    this.groupPlanFilterData.Group !== '' &&
                    this.groupPlanFilterData.Group.length < 3
                ) {
                    this.lengthErrorG = 'Minimum 3 characters'
                    this.hasError = true
                }
                if (
                    this.groupPlanFilterData.Carrier !== undefined &&
                    this.groupPlanFilterData.Carrier !== '' &&
                    this.groupPlanFilterData.Carrier.length < 3
                ) {
                    this.lengthErrorC = 'Minimum 3 characters'
                    this.hasError = true
                }
            }
        }

        if (!this.hasError) {
            this.getSTCOBDetails()
        }

        setTimeout(() => {
            this.runA11yFix();
        }, 300);
    }

    private runA11yFix(): void {
        if (!this.myGrid) return;
        const jqxEl = this.myGrid.elementRef.nativeElement as HTMLElement;
        const gridEl = jqxEl.querySelector('.jqx-grid') as HTMLElement;

        this.observeAndRemoveTabindex(gridEl);
        this.setupA11y();
        this.updateVisibleRowCount();

        requestAnimationFrame(() => {
            this.fixExternalJqxInputs();
        });
    }

    public getSTCOBDetails() {
        this.showWarning = false
        if (this.enrollmentDrugViewModel !== undefined) {
            this.groupPlanFilterData.StateCd = this.enrollmentDrugViewModel.APPST
            this.groupPlanFilterData.OrgID = this.enrollmentDrugViewModel.AGENTORGID
            this.groupPlanFilterData.ShowGroupOnly = true
        }

        this.loadingIcon = true
        this._enrollementGateway.getGroupPlanList(this.groupPlanFilterData).subscribe(
            (response: stcobModel[]) => {
                this.stcobDetails = response
                if (this.stcobDetails.length === 0) {
                    this.noGrpPlan = false
                    this.IsPlanvisible = false
                    this.noDataFound = true
                } else {
                    this.noGrpPlan = true
                    this.IsPlanvisible = true
                    this.noDataFound = false

                    if (this.stcobDetails.length >= 1000) {
                        this.showWarning = true
                    }
                }
                this.source.localdata = this.stcobDetails
                this.dataAdapter.dataBind()
                if (this.myGrid !== undefined) {
                    this.myGrid.updatebounddata()
                }
                this.loadingIcon = false
            },
            (err) => {
                this.loadingIcon = false
            }
        )
    }

    //focusFirstFilterBox() {
    //    const filters = document.querySelectorAll('.jqx-grid-cell-filter-row input');
    //    if (filters.length) {
    //        (filters[0] as HTMLElement).focus();
    //    }
    //}

    enableTabToSubmit() {
        const gridEl = this.myGrid.elementRef.nativeElement as HTMLElement;
        setTimeout(() => {
            const firstRow = gridEl.querySelector('.jqx-grid-content .jqx-grid-cell') as HTMLElement;
            if (firstRow) {
                firstRow.tabIndex = 0;
            }
            this.attachFilterToRowTab(firstRow);
            this.attachRowToSubmitTab(firstRow);
        }, 150);
    }

    attachFilterToRowTab(firstRow: HTMLElement | null) {
        const filters = document.querySelectorAll('.jqx-grid-cell-filter-row input');
        if (!filters.length || !firstRow)
            return;

        const lastFilter = filters[filters.length - 1] as HTMLElement;
        lastFilter.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();
                firstRow.focus();
                const rowIndex = 0;
                const row = this.myGrid.getrowdata(rowIndex);
                console.log("row in attachFilterToRowTab: ", row);
                const announcement = this.buildRowAnnouncement(row);
                this.announce(announcement);
            }
        });
    }

    attachRowToSubmitTab(firstRow: HTMLElement | null) {
        if (!firstRow)
            return;

        firstRow.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();
                this.focusSubmit.emit();
            }

            if (e.key === 'Tab' && e.shiftKey) {
                e.preventDefault();
                const rowIndex = this.currentRowIndex;
                const row = this.myGrid.getrowdata(rowIndex);
                console.log("row in attachFilterToRowTab: ", row);
                const announcement = this.buildRowAnnouncement(row);
                this.announce(announcement);
                firstRow.focus();

                //this.focusLastFilter();
            }
        });
    }

    focusLastFilter() {
        const filters = document.querySelectorAll('.jqx-grid-cell-filter-row input');
        if (filters.length) {
            (filters[filters.length - 1] as HTMLElement).focus();
        }
    }

    onGridFilter(event: any) {
        setTimeout(() => {
            const rows = this.myGrid.getrows();
            const count = rows ? rows.length : 0;

            const liveRegion = this.srAnnouncer.nativeElement as HTMLElement;

            if (!liveRegion) return;

            if (count === 0) {
                liveRegion.textContent = "No data to display";
                console.log('onFilter No Data: ', liveRegion.textContent);
            } else {
                liveRegion.textContent = `${count} result${count !== 1 ? 's' : ''} found`;
                console.log('onFilter data has: ', liveRegion.textContent);
            }
        }, 60);
    }

    onGridReady() {
        let attempts = 0;
        const checkInputs = () => {
            const filterInputs = document.querySelectorAll('.jqx-grid-cell-filter-row input');

            if (filterInputs.length === 0) {
                attempts++;
                if (attempts < 30) {
                    setTimeout(checkInputs, 50);
                }
                return
            }

            console.log('filterInputs: ', filterInputs);
            if (filterInputs.length > 0) {
                const first = (filterInputs[0] as HTMLInputElement);
                setTimeout(() => {
                    console.log('insideIf: ', filterInputs.length);
                    first.setAttribute('aria-label', 'Filter results');
                    first.focus();

                });

                const last = filterInputs[filterInputs.length - 1] as HTMLInputElement;

                last.addEventListener('keydown', (e: KeyboardEvent) => {
                    if (e.key === 'Tab' && !e.shiftKey) {
                        e.preventDefault();
                        this.focusFirstGridRow();
                    }
                });

            }

        };
        checkInputs();
    }

    focusFirstGridRow() {
        if (!this.myGrid) return;

        this.myGrid.selectrow(0);

        setTimeout(() => {
            const firstRow = document.querySelector('.jqx-grid-content .jqx-grid-cell') as HTMLElement;

            if (!firstRow) return;

            firstRow.setAttribute('tabindex', '0');
            firstRow.setAttribute('role', 'gridcell');
            firstRow.setAttribute('aria-selected', 'true');
            firstRow.focus();

            firstRow.addEventListener('keydown', (e: KeyboardEvent) => {
                if (e.key === 'Tab' && !e.shiftKey) {
                    e.preventDefault();
                    this.focusSubmit.emit();
                }

                if (e.key === 'Tab' && e.shiftKey) {
                    e.preventDefault();
                    this.focusLastFilter();
                }
            });
        }, 50);
    }

    focusFirstFilterBox() {
        setTimeout(() => {
            setTimeout(() => {
                const filterInputs = document.querySelectorAll('.jqx-grid-cell-filter-row input');
                console.log('filterInputs: ', filterInputs);
                if (filterInputs && filterInputs.length > 0) {
                    console.log('insideIf: ', filterInputs.length);
                    const firstInput = filterInputs[0] as HTMLInputElement;
                    firstInput.focus();
                    firstInput.click();
                }
            }, 100);
        }, 100);

        //let attempts = 0;

        //const checkInputs = () => {
        //    const filterInputs = document.querySelectorAll('.jqx-grid-cell-filter-row input');

        //    console.log('filterInputs: ', filterInputs);
        //    if (filterInputs.length > 0) {
        //        const first = (filterInputs[0] as HTMLInputElement);
        //        setTimeout(() => {
        //            console.log('insideIf: ', filterInputs.length);
        //            first.focus();
        //            first.click();

        //            first.dispatchEvent(new Event('input', { bubbles: true }));
        //            first.dispatchEvent(new Event('keyup', { bubbles: true }));

        //        })

        //        return;
        //    }
        //    attempts++;
        //    if (attempts < 30) {
        //        setTimeout(checkInputs, 50);
        //    }
        //};
        //checkInputs();

    }


    //enableTabToSubmit() {
    //    setTimeout(() => {
    //        const filterInputs = document.querySelectorAll('.jqx-grid-cell-filter-row input');
    //        if (filterInputs.length === 0) return;

    //        const lastFilterInput = filterInputs[filterInputs.length - 1];

    //        lastFilterInput.addEventListener('keydown', (e: any) => {
    //            const evt = e as KeyboardEvent;
    //            if (evt.key === 'Tab') {
    //                evt.preventDefault();
    //                this.focusSubmit.emit();
    //            }
    //        });
    //    }, 200);
    //}

    ngOnChanges(changes: SimpleChanges) { }
}
